module.exports = __webpack_public_path__ + "img/verified-status.b45423b5.png";